import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IRowNode } from 'ag-grid-community';
import { Component } from '@angular/core';
import { PeriodRendererParams } from '@core/typings/period-renderer.params';
import { NodeUtils } from '@core/utils/node.utils';
import { Period } from '@portal-shared/app/entities/period.model';
import { ProjectPeriodUsageDto } from '@services/dtos/rows/project-period-usage.dto';
import { CellDropZoneComponent } from '@shared/components/cell-drop-zone/cell-drop-zone.component';
import { PeriodSumsComponent } from '@shared/components/grids/row-cell-renderers/period-sums/period-sums.component';
import { ClassGroupRow } from '../../rows/groups/class-group.row';

@Component({
    selector: 'al-total-hours-period-cell-renderer',
    templateUrl: 'total-hours-period-cell-renderer.component.html',
    imports: [PeriodSumsComponent, CellDropZoneComponent]
})
export class TotalHoursPeriodCellRendererComponent implements ICellRendererAngularComp {
  public actualHours?: number;
  public assignedHours = 0;
  public period?: Period;
  public node?: IRowNode<ClassGroupRow>;

  public get isDroppable() {
    return NodeUtils.isCellDroppable(this.node);
  }

  public agInit(params: PeriodRendererParams<ClassGroupRow, ProjectPeriodUsageDto>) {
    this.update(params);
  }

  public refresh(params: PeriodRendererParams<ClassGroupRow, ProjectPeriodUsageDto>): boolean {
    void this.update(params);
    return true;
  }

  private update(params: PeriodRendererParams<ClassGroupRow, ProjectPeriodUsageDto>) {
    this.node = params.node;
    this.period = params.period;
    const periodAggData = params.value;

    if (!periodAggData) return;

    const { realHours: actualHours, assignedHours } = periodAggData;

    this.actualHours = this.period.hasActualHours ? actualHours ?? 0 : undefined;
    this.assignedHours = assignedHours ?? 0;
  }

  public expand(expand = true) {
    if (!this.node?.group) return;

    this.node?.setExpanded(expand);
  }
  public toggleExpand() {
    this.expand(!this.node?.expanded);
  }
}
